// Privacy Policy Texts

// type 0 = standard text
// type 1 = title (h5)
// type 2 = big title (h3)
const CST_WEBSITE = "Statelo";
const CST_WEBSITE_MAJ = "STATELO";
const CST_LASTUPDATE = "20 août 2023";

export const CST_POLICY_TEXT = [
{ type: 2, text: 
	"Politique sur la protection des renseignements personnels"
},
{ type: 0, text: 
	"DevAxia (ci-après « DevAxia », « nos », « nous » ou « notre ») accorde une importance " + 
	"particulière au respect de votre vie privée et à la protection de vos renseignements personnels, c’est " + 
	"pourquoi nous avons mis en place un programme de gestion des renseignements personnels et nommé un " + 
	"Responsable de la protection des renseignements personnels."
},
{ type: 0, text: 
	"La présente Politique sur la protection des renseignements personnels (ci-après la « Politique ») a pour " + 
	"objectif de vous informer de la façon dont DevAxia collecte, utilise, divulgue, conserve, partage et protège " + 
	"vos renseignements personnels."
},
{ type: 0, text: 
	"Afin de vous offrir des services de qualité, nous devons avoir accès à certains renseignements personnels " + 
	"vous concernant. Nous nous assurons que nos employés gèrent ces renseignements avec toute la discrétion et " + 
	"la rigueur nécessaires, et ce, en conformité avec les exigences légales et réglementaires en vigueur."
},

{ type: 1, text: 
	"RENSEIGNEMENT PERSONNEL"
},
{ type: 0, text: 
	"Nous entendons par « renseignement personnel » tout renseignement concernant une personne identifiable ou qui, " + 
	"pris séparément ou combiné avec d’autres données, permet d’identifier une personne. De façon générale, les " + 
	"renseignements personnels ne comprennent pas vos coordonnées professionnelles comme votre nom, votre titre, " + 
	"votre adresse ou votre numéro de téléphone au travail."
},

{ type: 1, text: 
	"COLLECTE DE RENSEIGNEMENTS PERSONNELS"
},
{ type: 0, text: 
  "Dans le cadre de nos interactions avec vous, que ce soit lors de notre prestation de services ou lors de nos activités, " + 
  "nous devons recueillir certains renseignements personnels vous concernant. Les renseignements personnels que nous " + 
  "recueillons sont nécessaires afin de vous offrir les services demandés. Cela comprend notamment sans s’y limiter :"
},
{ type: 3, text: 
  "Vos coordonnées comme un nom, une adresse, un courriel ou un numéro de téléphone;"
},
{ type: 3, text: 
  "Des renseignements fournis par nos clients ou pour le compte de ceux-ci ou que nous produisons dans le cadre de notre " + 
  "prestation de service et qui pourraient être compris comme des renseignements personnels;"
},
{ type: 3, text: 
  "Des renseignements relatifs à la facturation comme une adresse de facturation, des informations bancaires ou des données" + 
  " de système de paiement;"
},
{ type: 3, text: 
  "Des renseignements relatifs au marketing et aux préférences de communication comme des commentaires, des réponses à des sondages;"
},
{ type: 3, text: 
  "Des renseignements relatifs à l’utilisation de notre site web incluant des renseignements techniques sur les visites ou " + 
  "tout autre renseignement collecté à travers des témoins ou d’autres outils similaires;"
},
{ type: 3, text: 
  "Des renseignements relatifs au recrutement comme des CV, des renseignements sur vos antécédents professionnels ou académiques, " + 
  "ou tout autre renseignement pertinent pour un recrutement potentiel;"
},
{ type: 3, text: 
  "Des renseignements historiques comme le nom de vos anciens employeurs, vos titres de postes, du contenu numérique comme des " + 
  "photos, des vidéos ou des fichiers audio;"
},
{ type: 3, text: 
  "Tout autre renseignement personnel fourni."
},
{ type: 0, text: 
  ""
},

{ type: 1, text: 
	"FINS AUXQUELLES LES RENSEIGNEMENTS PERSONNELS SONT RECUEILLIS"
},
{ type: 0, text: 
  "DevAxia collecte, utilise et divulgue des renseignements personnels aux fins déterminées au moment de la collecte " + 
  "ou selon ce qui est permis ou exigé par la réglementation. Cela comprend notamment les fins suivantes :"
},
{ type: 3, text: 
  "Établir et gérer les relations avec nos clients;"
},
{ type: 3, text: 
  "Pour fournir nos produits / services et la conduite de nos affaires;"
},
{ type: 3, text: 
  "Partager des renseignements personnels à des tiers dans le cadre de nos services;"
},
{ type: 3, text: 
  "Établir des relations commerciales avec nos clients notamment pour la gestion de la facturation, l’administration de " + 
  "comptes, la perception et le traitement des paiements, limiter le risque d’impayés, permettre le recouvrement de paiements dus;"
},
{ type: 3, text: 
  "Satisfaire aux obligations légales, réglementaires ou de gestion de risques à l’égard de nos clients incluant " + 
  "notamment les vérifications diligentes à l’égard d’un client, l’obtention de renseignements nécessaires, détection des risques en matière de luttes contre la corruption, détection de conflits d’intérêts;"
},
{ type: 3, text: 
  "Prévenir la fraude et/ou effectuer toute vérification d’antécédents requise par la loi ou la réglementation applicable;"
},
{ type: 3, text: 
	"Permettre de faciliter l’utilisation de notre site web et assurer sa pertinence, suivre l’utilisation faite de notre site web, " + 
	"répondre aux questions soumises par l’entremise de notre site web;"
},
{ type: 3, text: 
  "Permettre le développement des affaires et le marketing afin notamment d’informer les clients actuels et futurs sur nos " + 
  "nouveaux services, fournir de l’information sur les développements juridiques récents ainsi que des invitations à des " + 
  "évènements sur accord préalable de la personne concernée;"
},
{ type: 3, text: 
  "Effectuer du développement et de la recherche afin de s’assurer de maintenir une sécurité du plus haut standard, " + 
  "de comprendre les exigences de notre clientèle pour améliorer notre offre;"
},
{ type: 3, text: 
  "Recruter du personnel, traiter les candidatures et évaluer le profil du ou de la candidate en lien avec les exigences du poste;"
},
{ type: 3, text: 
  "Tel que cela est permis ou exigé, pour toute obligation ou disposition légale ou réglementaire applicable;"
},
{ type: 3, text: 
  "Toute autre fin à laquelle vous avez consenti."
},
{ type: 0, text: 
  ""
},

{ type: 1, text: 
	"LIMITE À LA COLLECTE, À L’UTILISATION ET À LA DIVULGATION DE RESEIGNEMENTS PERSONNELS"
},
{ type: 0, text: 
  "DevAxia s’efforce de limiter la collecte de renseignements personnels à ce qui est strictement nécessaire afin " + 
  "d’accomplir les fins pour lesquelles ils sont recueillis. Soyez assurés que nous ne divulguerons ni n’utiliserons " + 
  "vos renseignements personnels à des fins autres, à moins que vous n’y consentiez ou que la loi ne le prévoie."
},
{ type: 0, text: 
  "De plus, comme vous pourrez le constater dans la section Mesures de sécurité relatives aux renseignements personnels " + 
  "nous limitons l’accès de vos renseignements personnels qu’aux personnes ayant la qualité et la nécessité d’y accéder, " + 
  "et ce, pour une fin spécifique."
},

{ type: 1, text: 
	"CONSENTEMENT"
},
{ type: 0, text: 
  "Règle générale, DevAxia obtiendra directement les renseignements personnels nécessaires auprès de vous, et ce, " + 
  "avec votre consentement, sous réserve des exceptions prévues à la loi."
},
{ type: 0, text: 
  "Nous pouvons également recueillir des renseignements personnels auprès de tiers ou de dossiers publics accessibles " + 
  "selon ce qui est permis par la loi ou si nous avons recueilli le consentement nécessaire."
},
{ type: 0, text: 
  "DevAxia ne recueillera, n’utilisera, ni ne divulguera les renseignements personnels sans votre consentement à moins " + 
  "qu’il ne soit autorisé ou obligé de le faire en vertu de la réglementation applicable. À titre d’exemple, DevAxia " + 
  "pourrait devoir procéder sans votre consentement notamment pour les raisons suivantes :"
},
{ type: 3, text: 
  "Lorsque nous obtenons des renseignements personnels d’un tiers par notre client dans le cadre de notre prestation de services;"
},
{ type: 3, text: 
  "Lorsque, pour des raisons de sécurité ou d’ordre médical ou juridique, il nous est impossible d’obtenir votre consentement;"
},
{ type: 3, text: 
  "Lorsque, pour des raisons de détection ou de prévention de la fraude ou pour l’application de la loi, le fait de " + 
  "demander le consentement de l’individu ferait échouer la démarche."
},
{ type: 0, text: 
  ""
},
{ type: 0, text: 
  "À noter que vous avez le droit de refuser de nous communiquer des renseignements personnels. Vous avez également le " + 
  "droit, sous réserve d’un préavis raisonnable et des restrictions légales ou contractuelles applicables, de retirer " + 
  "votre consentement concernant l’utilisation des renseignements personnels déjà collectés en communiquant avec notre " + 
  "Responsable de la protection des renseignements personnels. Le refus de communiquer des renseignements ou le retrait " + 
  "de votre consentement pourraient nous empêcher de fournir ou de continuer à vous fournir certains de nos services."
},
{ type: 0, text: 
  "DevAxia pourrait également vous demander votre consentement à des fins secondaires, par exemple pour vous inviter à des " + 
  "événements ou à des formations, pour réaliser des études de marché ou pour alimenter ses bases de données. Tel que nous " + 
  "l’avons mentionné précédemment, nous vous demanderons votre consentement à cet égard. De plus, votre consentement à des " + 
  "fins secondaires peut être retiré en tout temps, et ce, sans affecter la prestation de nos services auprès de vous."
},
{ type: 0, text: 
  ""
},

{ type: 1, text: 
	"PARTAGE DE RENSEIGNEMENTS PERSONNELS"
},
{ type: 0, text: 
	"Afin de vous fournir nos services, il se peut que nous procédions à la transmission des renseignements personnels collectés " + 
  "avec certains tiers."
},
{ type: 0, text: 
	"Dans le cadre de ses activités, DevAxia pourrait divulguer vos renseignements à de tierces parties ce qui inclut notamment :"
},
{ type: 3, text: 
	"Des tiers en lien avec nos services;"
},
{ type: 3, text: 
	"Des tiers fournisseurs de services incluant notamment les services relatifs à notre site web (hébergement, sécurité, etc.). " + 
  "Les renseignements personnels fournis sont alors limités aux seuls renseignements nécessaires pour leur permettre de réaliser " + 
  "leurs services et ces fournisseurs sont obligés de préserver la confidentialité de ces renseignements;"
},
{ type: 3, text: 
	"Des autorités publiques gouvernementales et des organismes d’application de la loi lorsque les lois applicables l’exigent " + 
  "ou lorsque cela est nécessaire pour la fourniture de nos services."
},
{ type: 0, text: 
	""
},
{ type: 0, text: 
	"En aucun temps, DevAxia ne vendra ni n’échangera vos renseignements personnels moyennant paiement."
},

{ type: 1, text: 
	"CONSERVATION DES RENSEIGNEMENTS PERSONNELS"
},
{ type: 0, text: 
	"Les renseignements personnels ne sont conservés que pour la durée nécessaire aux fins prévues dans la présente " + 
  "Politique et afin de nous assurer d’être en conformité avec nos obligations légales et réglementaires."
},
{ type: 0, text: 
	"Si vous souhaitez en apprendre davantage sur la durée de conservation de vos renseignements personnels, nous " + 
  "vous invitons communiquer avec notre Responsable de la vie privée."
},

{ type: 1, text: 
	"MESURES DE SÉCURITÉ RELATIVES AUX RENSEIGNEMENTS PERSONNELS"
},
{ type: 0, text: 
	"DevAxia s’efforce d’appliquer les mesures de sécurité nécessaires et appropriées afin d’assurer le caractère " + 
  "confidentiel des renseignements personnels en sa possession. Pour ce faire, nous suivons notamment les standards " + 
  "généralement acceptés dans l’industrie. Les renseignements personnels que nous détenons ne sont donc accessibles " + 
  "qu’aux personnes qui ont qualité pour en prendre connaissance et qui les consultent uniquement lorsque cela est " + 
  "nécessaire dans l’exercice de leurs fonctions."
},
{ type: 0, text: 
	"Des mesures de protection et de sécurité physiques, techniques et/ou administratives appropriées ont été mises " + 
  "en place et sont maintenues à jour afin d’éviter:"
},
{ type: 3, text: 
	"Toute destruction accidentelle ou non conforme aux lois;"
},
{ type: 3, text: 
	"Toute perte accidentelle;"
},
{ type: 3, text: 
	"Toute divulgation non autorisée;"
},
{ type: 3, text: 
	"Toute modification non autorisée;"
},
{ type: 3, text: 
	"Tout accès non autorisé;"
},
{ type: 3, text: 
	"Tout traitement illégal."
},
{ type: 0, text: 
	""
},
{ type: 0, text: 
	"Pour ce faire, nous nous assurons notamment de restreindre les accès à nos bureaux et aux équipements informatiques, " + 
  "de former notre personnel et de requérir de nos mandataires et fournisseurs de biens et de services ayant accès à " + 
  "des renseignements personnels de signer des ententes de confidentialité et de mettre en place des mesures de sécurité " + 
  "jugées équivalentes."
},
{ type: 0, text: 
	"À noter, toutefois qu’aucune méthode de transmission par Internet, ni aucun moyen de stockage électronique n’est " + 
  "totalement sécuritaire. Nous ne pouvons donc garantir la sécurité des renseignements personnels qui nous sont " + 
  "transmis ou que vous nous fournissez, cela étant fait à vos risques et périls."
},
{ type: 0, text: 
	"Nous ne pouvons également pas garantir que ces renseignements personnels ne seront pas obtenus, consultés, " + 
  "divulgués, modifiés ou détruits à la suite d’une violation de nos mesures de protection et de sécurité."
},
{ type: 0, text: 
	"Si vous pensez que vos renseignements personnels ont été compromis, nous vous invitons à prendre contact avec " + 
  "nous en utilisant les coordonnées listées dans la section « Contact » de cette Politique."
},

{ type: 1, text: 
	"VOS DROITS"
},
{ type: 0, text: 
	"Selon les lois applicables, vous pourriez avoir le droit d’obtenir l’accès à vos renseignements personnels, " + 
  "leur rectification ou leur effacement, le droit de retirer votre consentement (le cas échéant), le droit d’être " + 
  "informé d’une décision fondée exclusivement sur un traitement automatisé (le cas échéant), le droit de ne pas " + 
  "être discriminé, le droit de restreindre et de s’opposer à l’utilisation et au traitement de vos renseignements " + 
  "personnels par DevAxia, ou le droit à la portabilité des données, à savoir recevoir une copie de tous les " + 
  "renseignements personnels que DevAxia possède à votre sujet dans un format structuré, couramment utilisé et " + 
  "lisible par machine."
},
{ type: 0, text: 
	"Pour exercer l’un de ces droits (dans la mesure où ils sont disponibles), veuillez nous soumettre votre demande " + 
  "en écrivant au Responsable de la protection des renseignements personnels, comme indiqué dans la " + 
  "section « Nous contacter ». En fonction du droit exercé, nous vous informerons de la procédure à suivre, " + 
  "du délai de traitement (délai de réponse) et des informations nécessaires."
},

{ type: 1, text: 
	"PROGRAMME DE GESTION DES RENSEIGNEMENTS PERSONNELS"
},
{ type: 0, text: 
	"Afin de protéger vos renseignements personnels, nous avons mis en place des politiques, pratiques et procédures " + 
  "relatives à la gestion des renseignements personnels que nous détenons."
},
{ type: 0, text: 
	"Ces politiques et procédures internes régissent la collecte, l’utilisation, la divulgation, la conservation et " + 
  "la destruction des renseignements personnels ainsi que le traitement des plaintes, la sécurité de l’information " + 
  "et la gouvernance des données. Elles fournissent également le cadre de la mise en œuvre des évaluations des " + 
  "facteurs relatifs à la vie privée ainsi qu’en matière de prévention et de réponse potentielle aux incidents de confidentialité."
},

{ type: 1, text: 
	"RESPONSABLE DE LA PROTECTION DES RENSEIGNEMENTS PERSONNELS"
},
{ type: 0, text: 
	"La direction de DevAxia a délégué la gestion du programme de gestion des renseignements personnels au Responsable " + 
  "de la protection des renseignements personnels. Le Responsable de la protection des renseignements personnels est chargé " + 
  "de la gestion interne et de la surveillance du programme de gestion des renseignements personnels de DevAxia."
},
{ type: 0, text: 
	"Le Responsable de la protection des renseignements personnels est chargé d’approuver et de mettre en œuvre les politiques " + 
  "et procédures de protection des renseignements personnels, de s’assurer de leur bon fonctionnement et de rendre compte à " + 
  "la direction de DevAxia de l’efficacité du programme."
},
{ type: 0, text: 
	"Il lui incombe également de vous fournir le soutien nécessaire en cas de question, de plainte ou de demande relative à " + 
  "la protection des renseignements personnels."
},

{ type: 1, text: 
	"PRÉCISIONS SUR LA COLLECTE, L’UTILISATION ET LA COMMUNICATION DE DONNÉES SUR LE SITE WEB DE " + CST_WEBSITE_MAJ
},
{ type: 1, text: 
	"À quelles fins recueillons-nous des renseignements personnels sur le site ?"
},
{ type: 0, text: 
	"Les renseignements personnels que nous recueillons sur vous sur le site sont recueillis afin notamment de " + 
  "communiquer avec vous."
},
{ type: 1, text: 
	"Utilisation de fichiers témoins (cookies)"
},
{ type: 0, text: 
	"Un témoin est un petit fichier de données créé par votre navigateur et placé sur votre ordinateur, " + 
  "appareil mobile, tablette ou autre appareil lorsque vous vous utilisez votre navigateur pour visiter " + 
  "un service en ligne. Les témoins permettent aux sites Web de mémoriser certaines informations à votre " + 
  "sujet en vue de faciliter votre accès et votre navigation Internet à l’intérieur de nos sites. Les " + 
  "fichiers témoins ne peuvent être lus que par le site Web qui les transmet à votre ordinateur."
},
{ type: 0, text: 
	"Nous utilisons certains fichiers témoins sur le site notamment pour :"
},
{ type: 3, text: 
	"Mémoriser vos réglages et préférences. Les témoins nous indiquent vos préférences, par exemple, votre province ou votre langue."
},
{ type: 3, text: 
	"Produire des compilations statistiques. Nous utilisons des témoins, entre autres, pour déterminer la popularité des pages " + 
  "de notre site, le nombre moyen de pages visitées et le temps moyen que chaque internaute passe dans le site et ainsi " + 
  "améliorer nos services."
},
{ type: 3, text: 
	"Analyser nos performances afin, notamment, d’en connaître davantage sur les fonctions appréciées de nos utilisateurs " + 
  "et celles pouvant nécessiter quelques modifications."
},
{ type: 0, text: 
	""
},
{ type: 0, text: 
	"Veuillez noter que l’utilisation de fichiers témoin permet seulement de vous identifier en tant qu’utilisateur et ne " + 
  "vous reconnaît pas au moyen de votre nom ni de votre adresse."
},

{ type: 1, text: 
	"Google Analytics"
},
{ type: 0, text: 
	"DevAxia a recours à Google Analytics dans le but d’analyser les comportements de navigation des visiteurs de son site. " + 
  "Il s’agit d’un outil d’analyse de la fréquentation et de l’utilisation de sites Web, lequel est fourni par Google Inc. " + 
  "(Google). En utilisant cet outil, DevAxia peut notamment obtenir les renseignements suivants :"
},
{ type: 3, text: 
	"le nombre de visiteurs du site;"
},
{ type: 3, text: 
	"le type de navigateur, la langue et le système d’exploitation qu’ils utilisent;"
},
{ type: 3, text: 
	"la résolution d’écran;"
},
{ type: 3, text: 
	"le nom du fournisseur de services;"
},
{ type: 3, text: 
	"la date, l’heure et la durée des visites;"
},
{ type: 3, text: 
	"le pays/province d’où le site est consulté;"
},
{ type: 3, text: 
	"l’âge/sexe;"
},
{ type: 3, text: 
	"les pages consultées;"
},
{ type: 3, text: 
	"la source (provenance) du trafic, soit organique/direct/référent/médias sociaux;"
},
{ type: 3, text: 
	"les centres d’intérêts;"
},
{ type: 3, text: 
	"les termes de recherche à l’intérieur du site Web (champs de recherche)."
},
{ type: 0, text: 
	""
},
{ type: 0, text: 
	"Les renseignements recueillis par Google Analytics servent à analyser l’utilisation du site de " + CST_WEBSITE + " et à produire " + 
  "des rapports statistiques sur les activités des visiteurs. Vous pouvez obtenir davantage d’information sur Google Analytics ici."
},

{ type: 1, text: 
	"Désactivation de fichiers témoins (cookies)"
},
{ type: 0, text: 
	"Il est possible d’empêcher les fonctions de personnalisation de notre site en désactivant les témoins sur votre navigateur. " + 
  "Vous pouvez le faire en modifiant les paramètres de votre navigateur ou de votre appareil mobile."
},
{ type: 0, text: 
	"Toutefois, si vous décidez de refuser les témoins, certaines pages ou sections de notre site Web pourraient ne pas s’afficher " + 
  "correctement ou certaines fonctionnalités pourraient ne pas être disponibles."
},

{ type: 1, text: 
	"UTILISATION DE reCAPTCHA DANS NOTRE FORMULAIRE WEB"
},
{ type: 0, text: 
	"Nous pourrions utiliser le service reCAPTCHA de Google Inc. (Google) pour protéger les entrées des formulaires sur notre " + 
  "site Web. Google reCAPTCHA est utilisé afin de vérifier si les données saisies sur notre site (formulaire de contact) ont " + 
  "été saisies par un humain ou par un programme automatisé. En d’autres mots, ce service nous permet de distinguer les " + 
  "humains des ordinateurs, de telle sorte que les robots soient incapables de remplir les formulaires de façon malveillante."
},
{ type: 0, text: 
	"Pour plus d’information, nous vous invitons à consulter le site Web Google reCAPTCHA ainsi que de prendre connaissance " + 
  "de leur politique de confidentialité."
},
{ type: 0, text: 
	"En utilisant le service reCAPTCHA, vous consentez au traitement par Google des données vous concernant, de la manière " + 
  "et aux fins énoncées dans leurs politiques."
},

{ type: 1, text: 
	"LIENS VERS DES SITES"
},
{ type: 0, text: 
	"Il est important de comprendre que cette Politique ne s’applique pas à d’autres sites Web tiers auxquels il serait " + 
  "possible d’accéder à partir de liens présents sur notre site Web. Nous ne sommes nullement responsables à l’égard de " + 
  "ces sites tiers, de leur contenu ou de leur accès. Par conséquent, tout renseignement personnel que vous transmettez " + 
  "par l’intermédiaire de ces sites est assujetti à la politique de protection de la vie privée de ces derniers. Il est " + 
  "de votre responsabilité d’en prendre connaissance afin d’assurer la protection de vos renseignements personnels."
},

{ type: 1, text: 
	"NOUS CONTACTER"
},
{ type: 0, text: 
	"Vous pouvez nous contacter pour exercer vos droits, ou si vous avez des questions sur nos pratiques en matière de " + 
  "protection des renseignements personnels ou si vous avez besoin d’assistance pour exercer ou comprendre vos choix " + 
  "en matière de confidentialité."
},
{ type: 0, text: 
	"Pour toute demande d’information, veuillez nous contacter par courriel au info@devaxia.com."
},
{ type: 0, text: 
	"DevAxia s’engage à répondre rapidement à vos questions et préoccupations concernant la confidentialité et la sécurité " + 
  "de vos Renseignements personnels et nos politiques et procédures en la matière."
},
{ type: 0, text: 
	"Si vous avez une plainte concernant l’exercice de vos droits en vertu de cette Politique, votre dossier sera traité " + 
  "par le Responsable de la protection des renseignements personnels de DevAxia, qui vous informera des procédures à " + 
  "suivre. Chaque plainte fera l’objet d’une analyse. Si la plainte est justifiée, la situation spécifique sera corrigée " + 
  "et vous en serez informé."
},

{ type: 1, text: 
	"MISE À JOUR DE CETTE POLITIQUE"
},
{ type: 0, text: 
	"DevAxia révise fréquemment cette Politique afin de la maintenir à jour selon la législation applicable et ses " + 
  "opérations. Si des modifications importantes sont apportées à la Politique, des avis de mise à jour (tels que " + 
  "des avis en ligne ou des courriels) peuvent être utilisés pour vous aviser de ces modifications. Dans le cas " + 
  "contraire, la publication de la Politique révisée sur le site sera considérée comme un avis suffisant et, en " + 
  "continuant à utiliser le site ou en nous soumettant des renseignements personnels, vous acceptez les modifications " + 
  "apportées à notre Politique."
},
{ type: 0, text: 
	"Dernière mise-à-jour: " + CST_LASTUPDATE
},
{ type: 0, text: 
	"De toutes les versions traduites de cette Politique, la version française prévaudra en cas de différents."
},

];

